var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ph:phone-fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.7388 16.4138C21.5716 17.6841 20.9477 18.8502 19.9837 19.6942C19.0196 20.5382 17.7813 21.0023 16.5 21.0001C9.05626 21.0001 3.00001 14.9438 3.00001 7.50005C2.99771 6.21876 3.4619 4.98045 4.30588 4.01639C5.14986 3.05234 6.31592 2.42847 7.58626 2.2613C7.9075 2.22208 8.2328 2.2878 8.51362 2.44865C8.79444 2.60951 9.0157 2.85687 9.14438 3.1538L11.1244 7.57412V7.58537C11.2229 7.81267 11.2636 8.06083 11.2428 8.30769C11.222 8.55455 11.1404 8.79242 11.0053 9.00005C10.9884 9.02537 10.9706 9.0488 10.9519 9.07224L9.00001 11.386C9.7022 12.8129 11.1947 14.2922 12.6403 14.9963L14.9222 13.0547C14.9446 13.0359 14.9681 13.0184 14.9925 13.0022C15.2 12.8639 15.4387 12.7794 15.687 12.7565C15.9353 12.7336 16.1854 12.7729 16.4147 12.871L16.4269 12.8766L20.8434 14.8557C21.1409 14.9839 21.3889 15.205 21.5503 15.4858C21.7116 15.7667 21.7778 16.0922 21.7388 16.4138Z",
    fill: "#00A0FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.4e9d478a2ec643f122b8530196d0303a.svg";
export { ForwardRef as ReactComponent };